<template>
  <div class="default-upload">
    <div class="upload-tab-wrapper">
      <span class="upload-tab-item left" :class="{ active: currentUpload === 'PDFUpload' }" @click="switchUpload('PDFUpload')">创建电子书刊</span>
      <span class="upload-tab-item middle" :class="{ active: currentUpload === 'PaperUpload' }" @click="switchUpload('PaperUpload')">创建数字报</span>
      <span class="upload-tab-item right" :class="{ active: currentUpload === 'VideoUpload' }" @click="switchUpload('VideoUpload')">创建视频推荐</span>
    </div>
    <div class="upload-content">
      <component :is="currentUpload" @updateUploadingStatus="updateUploadingStatus"></component>
    </div>
    <div class="upload-button-wrapper">
      <div v-if="currentUpload === 'PDFUpload'" class="upload-header-button shallow large" @click="goDefaultEdit()">
        <img class="upload-header-button-icon" src="../assets/imgs/icon_defaultSetting.png" />
        <span>书刊默认效果设置</span>
      </div>
      <div v-if="currentUpload !== 'VideoUpload'" class="upload-header-button shallow" @click="precisonClick">
        <img class="upload-header-button-icon" src="../assets/imgs/icon_setting.png" />
        <span>参数设置</span>
      </div>
      <div v-if="currentUpload === 'PaperUpload'" class="upload-header-button dark middle" @click="toList">
        <img class="upload-header-button-icon" src="../assets/imgs/icon_book_list.png" />
        <span>我的数字报</span>
      </div>
      <div class="upload-header-button dark" @click="toList" v-else>
        <img class="upload-header-button-icon" :src="currentUpload === 'PDFUpload' ? require('../assets/imgs/icon_book_list.png') : require('../assets/imgs/icon_video_list.png')" />
        <span>{{ currentUpload === 'PDFUpload' ? '我的书刊' : '我的视频' }}</span>
      </div>
    </div>
    <div class="statement">
      <p>1、通过本平台上传的文件必须遵守<span class="agreement" @click="toAgreement">&lt;&lt;方正飞翔云服务用户上传协议>></span>，请您须知。</p>
      <p>2、每个账户可免费享有1GB云存储空间（生成{{ currentUpload === 'PaperUpload' ? '数字报' : '电子书' }}文件所占存储）。</p>
      <p>
        {{
          currentUpload === 'PDFUpload'
            ? '3、如需体验内容检索功能，请确保上传的是非转曲PDF文件。'
            : currentUpload === 'VideoUpload'
            ? '3、上传MP4文件标准为H.264，文件大小不超过100M，如您文件不符合要求可尝试使用第三方工具进行转换，如：格式工厂、狸窝等。'
            : ''
        }}
      </p>
      <p v-if="currentUpload === 'PDFUpload'">
        4、建议上传PDF文件大小不超过100M，如您文件过大可尝试使用第三方工具进行压缩，如：smallPDF、i love pdf 等。
      </p>
    </div>
    <Precision :setting="additionalSetting" ref="precision"></Precision>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions"></tip-dialog>
  </div>
</template>
<script>
import PDFUpload from '@views/PDFUpload.vue'
import PaperUpload from '@views/PaperUpload.vue'
import VideoUpload from '@views/VideoUpload.vue'
import apis from '@api/login'
import Precision from '@components/precisionSetting/Default.vue'
import { mapState } from 'vuex'
import compareVipRight from '@components/common/compareVipRight.js'
import TipDialog from '@components/common/TipDialog.vue'
import { getDefaultSetting } from '@api/setBook'

export default {
  name: 'Make',
  data() {
    return {
      settingStatus: false,
      precisionVisible: false,
      additionalSetting: {
        dpi: this.dpi,
        open: this.open,
        referer: this.referer,
        displayPageNo: this.displayPageNo
      },
      currentUpload: 'PDFUpload'
    }
  },
  mixins: [compareVipRight],
  computed: {
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    },
    userName() {
      return localStorage.getItem('username')
    },
    ...mapState('config', {
      open: (state) => state.bookObj.open,
      dpi: (state) => String(state.bookObj.dpi),
      referer: (state) => state.bookObj.referer,
      displayPageNo: (state) => state.bookObj.displayPageNo
    })
  },
  methods: {
    // 切换上传内容
    switchUpload(component) {
      // 上传过程中不可切换到另一上传模块
      if (this.uploadingStatus === 'uploading' || this.uploadingStatus === 'singleUploading' || this.uploadingStatus === 'batchUploading') {
        return
      }
      this.currentUpload = component
    },
    toList() {
      if (this.userName) {
        const param = this.currentUpload === 'PDFUpload' ? 'book' : this.currentUpload === 'PaperUpload' ? 'paper' : 'video'
        this.$router.push({ name: 'list', params: { to: param } })
      } else {
        this.login()
      }
    },
    async goDefaultEdit() {
      if (this.userName) {
        if (!(await this.compareRight({ type: 'boole', key: 'defaultSetting' }))) {
          this.$refs.memberDialog.visible = true
          return
        }
        const param = 'edit'
        this.$router.push({ name: 'list', params: { to: param } })
      } else {
        this.login()
      }
    },
    toAgreement() {
      this.$router.push('/agreement')
    },
    login() {
      apis.login().then((res) => {
        if (res && res.data && res.status === 200) {
          let data = res.data
          if (data.code === 101) {
            window.location.href = data.data
          }
        }
      })
    },
    precisonClick() {
      this.additionalSetting = {
        dpi: this.dpi,
        open: this.open,
        referer: this.referer,
        displayPageNo: this.displayPageNo
      }
      this.$refs.precision.dialogVisible = true
    },
    closePrecisionDialog(status) {
      this.precisionVisible = status
    },
    updateUploadingStatus(status) {
      //ready uploading singleUploading batchUploading done
      this.uploadingStatus = status
    }
  },

  mounted() {},
  created() {
    this.currentUpload = this.$route.params.to || 'PDFUpload'
    getDefaultSetting().then((res) => {
      if (res.data.status === 0 && res.data.data != null) {
        this.$store.commit('config/UPDATE_DPI', res.data.data.dpi)
      }
    })
  },
  components: {
    PDFUpload,
    PaperUpload,
    VideoUpload,
    TipDialog,
    Precision
  }
}
</script>
<style lang="scss">
.default-upload {
  background: #f4f4f4;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 34px;
  height: calc(100% - 80px);
  box-sizing: border-box;
  cursor: default;
  .upload-tab-wrapper {
    height: 40px;
    display: inline-flex;
    align-items: center;
    margin-bottom: 43px;
    cursor: pointer;
    .upload-tab-item {
      width: 150px;
      height: 40px;
      background-color: #ffffff;
      color: #df5813;
      text-align: center;
      line-height: 38px;
      border: 1px solid #df5813;
      &.left {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
      }
      &.right {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      }
      &.active {
        background-color: #df5813;
        color: #ffffff;
      }
    }
  }
  .upload-header {
    width: 600px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 18px;
    .upload-header-title {
      height: 22px;
      font-size: 16px;
      line-height: 22px;
      display: inline-flex;
      align-items: center;
      margin-left: 10px;
      .upload-header-title-label {
        width: 2px;
        height: 16px;
        background-color: #df5813;
        margin-right: 10px;
      }
    }
    .upload-header-button-wrapper {
      .upload-header-button {
        width: 92px;
        height: 28px;
        line-height: 28px;
        display: inline-flex;
        align-items: center;
        justify-content: space-around;
        font-size: 14px;
        color: #ffffff;
        background-color: #df5813;
        border-radius: 2px;
        padding: 0 4px;
        margin-right: 10px;
        cursor: pointer;
        &.shallow {
          color: #df5813;
          background-color: #ffffff;
          border: 1px solid #df5813;
        }
        .upload-header-button-icon {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
  .upload-button-wrapper {
    margin-top: 10px;
    width: 600px;
    text-align: right;
    .upload-header-button {
      width: 92px;
      height: 28px;
      line-height: 28px;
      display: inline-flex;
      align-items: center;
      justify-content: space-around;
      font-size: 14px;
      color: #ffffff;
      background-color: #df5813;
      border-radius: 2px;
      padding: 0 4px;
      margin-right: 10px;
      cursor: pointer;
      &.shallow {
        color: #df5813;
        background-color: #ffffff;
        border: 1px solid #df5813;
      }
      &.middle {
        width: 100px;
      }
      &.large {
        width: 150px;
      }
      .upload-header-button-icon {
        width: 20px;
        height: 20px;
      }
    }
  }
  .upload-content {
    width: 600px;
    height: 240px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 0 auto;
    border: dashed 1px #979797;
    border-radius: 8px;
    background-color: #fff;
  }
  .statement {
    font-size: 14px;
    color: #000;
    margin-top: 20px;
    width: 530px;
    font-size: 14px;
    div {
      padding: 7px 0;
    }
    span {
      color: #df5813;
      cursor: pointer;
    }
    a {
      text-decoration: none;
      color: #df5813;
    }
  }
}
</style>
